import { useSubscription } from '@/hooks/useSettings';
import { formatDate } from '@/lib/format';
import { Screen } from '@m/ui/Screen';
import { Group, Row } from '@m/ui/List';
import { Button, SkeletonList } from '@m/ui/Controls';
import { PLAN_LABEL, openDesktop } from './labels';

const STATUS: Record<string, string> = {
  active: 'Active',
  trialing: 'Trial',
  past_due: 'Payment failed',
  canceled: 'Canceled',
  none: 'No subscription'
};

/** The plan, read-only. Changing it (Stripe checkout and portal) happens on billable.to. */
export function SubscriptionScreen() {
  const sub = useSubscription();
  const s = sub.data;
  return (
    <Screen title="Subscription" back="/more" backLabel="More">
      {!s ? (
        <SkeletonList rows={4} />
      ) : (
        <>
          <Group>
            <Row title="Plan" detail={PLAN_LABEL[s.tier]} />
            <Row title="Status" detail={<span className={s.status === 'past_due' ? 'text-[var(--danger)]' : undefined}>{STATUS[s.status] ?? s.status}</span>} />
            {s.trialEndsAt && s.status === 'trialing' && <Row title="Trial ends" detail={formatDate(s.trialEndsAt.slice(0, 10))} />}
            {s.currentPeriodEnd && (
              <Row title={s.cancelAtPeriodEnd ? 'Ends' : 'Renews'} detail={formatDate(s.currentPeriodEnd.slice(0, 10))} />
            )}
          </Group>
          <Group header="Usage">
            <Row title="Seats" detail={`${s.usage.seatsUsed + s.usage.seatsPending} of ${s.seats}`} />
            <Row
              title="Invoices this month"
              detail={s.usage.invoiceLimit != null ? `${s.usage.invoicesThisMonth} of ${s.usage.invoiceLimit}` : String(s.usage.invoicesThisMonth)}
            />
          </Group>
          <Button variant="secondary" onClick={() => openDesktop('/settings/subscription')}>
            Manage billing on billable.to
          </Button>
        </>
      )}
    </Screen>
  );
}
